<!-- 企业级-业务领域-扫码支付业务 -->
<template>
  <div class="mainArea CExConfigSetting">
      
        <!-- <div class="searchDiv mt20">
          <div>
            <div class="dib"><el-input placeholder="请输入设备ID" v-model="keyword.device_id" clearable></el-input></div>
            <el-button type="primary" @click="getWarehouse(1)">搜索</el-button>
          </div>
        </div> -->
        <el-button type="primary" class="mb20 mt20" @click="openAdd">添加</el-button>
        <div class="tabList">
          <el-table :data="configList" style="width: 100%" v-loading="tableLoading">
            <el-table-column type="index" label="序号" width="100"></el-table-column>
            <el-table-column prop="device_info[0].device_type" label="设备类型"></el-table-column>
            <el-table-column label="设备ID">
              <template slot-scope="scope">
                <el-button type="text" @click="openTactics(scope.row.device_info,'1')">查看</el-button>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="device_name" label="设备名称"></el-table-column> -->
            <el-table-column label="价格策略">
              <template slot-scope="scope">
                <el-button type="text" @click="openTactics(scope.row.tactics,'2')">查看</el-button>
              </template>
            </el-table-column>
            <el-table-column label="寄存二维码">
              <template slot-scope="scope">
                <el-button type="text" @click="previewImg(scope.row.id,'jc')">查看</el-button>
              </template>
            </el-table-column>
            <!-- <el-table-column label="取件二维码">
              <template slot-scope="scope">
                <el-button type="text" @click="previewImg(scope.row.id,'jp')">查看</el-button>
              </template>
            </el-table-column> -->
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="openEdit(scope.$index)">修改</el-button>
                <el-button type="text" @click="openStatus(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="paging" v-if="total>page">
          <el-pagination
            @current-change="CurrentChange"
            :current-page.sync="curr"
            :page-size="page"
            layout="prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      <!--添加配置-->
      <el-dialog title="添加配置" :visible.sync="addConfigDio" width="700px" class="configDio">
        <div class="contDio">
          <el-form ref="form" :model="addform" label-width="90px">
            <el-form-item label="设备类型:">
              <div class="flex">
                <el-select v-model="addform.type" placeholder="请选择设备类型" class="db" @change="typeChange('1')">
                  <el-option
                    v-for="item in typeList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <div class="tit flex">
              <div>授权设备:</div>
              <div class="col6">已选择：{{addform.device_id.length}}项</div>
            </div>
            <div class="authUserList flex mb20">
              <div class="userTree">
                <el-tree
                ref="tree"
                class="defineTree"
                :data="spaceList"
                highlight-current
                default-expand-all
                node-key="space_id"
                :expand-on-click-node="false"
                :props="adminTreeProp"
                @node-click="getNode">
                  <span class="custom-tree-node" slot-scope="{ node,data }">
                    <i
                      class="defineIcon"
                      :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
                    </i>
                    <span class="label" :class="data.space_id === addform.space_id ? 'selectedTree' : ''">{{ node.label }}</span>
                  </span>
                </el-tree>
              </div>
              <div class="checkList">
                <div class="search">
                  <el-input size="small" placeholder="请输入搜索内容" prefix-icon="el-icon-search" v-model="addform.search" @input="searchDevice"></el-input>
                  <div class="sizeDiv" v-if="addform.type == 'ACCESS'">
                    <p>门禁级别：</p>
                    <el-checkbox-group v-model="addform.sizeCheck" @change="getSpaceDeviceSmzf(addform.type,'1',spaceList[0].space_id,addform.sizeCheck)">
                      <el-checkbox label="A"></el-checkbox>
                      <el-checkbox label="B"></el-checkbox>
                      <el-checkbox label="C"></el-checkbox>
                    </el-checkbox-group>
                  </div>
                </div>
                <el-checkbox class="dblock" :indeterminate="addform.isIndeterminate" v-model="addform.checkAll" @change="CheckAllChange">全选</el-checkbox>
                <el-checkbox-group class="groupH" v-model="addform.device_id" @change="CheckedItemChange" v-if="deviceList.length !== 0">
                  <el-checkbox class="dblock" v-for="(item,index) in deviceList" :label="item.device_no_id" :key="index">{{item.device_no_id}}-{{item.device_name}}</el-checkbox>
                </el-checkbox-group>
                <p class="nullText" v-else>暂无{{addform.typeName}}设备</p>
              </div>
            </div>
            <el-form-item label="价格策略:" prop="tactics_id">
              <el-select v-model="addform.tactics_id" placeholder="请选择设备名称">
                <el-option
                  v-for="item in tacList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addConfig('form')">确定</el-button>
          <el-button @click="addConfigDio = false">取消</el-button>
        </span>
      </el-dialog>

      <!--修改配置-->
      <el-dialog title="修改配置" :visible.sync="editConfigDio" width="700px" class="configDio">
        <div class="contDio">
          <el-form ref="form2" :model="editform" label-width="90px">
            <el-form-item label="设备类型:">
              <div class="flex">
                <el-select v-model="editform.type" placeholder="请选择设备类型" class="db" @change="typeChange('2')">
                  <el-option
                    v-for="item in typeList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <div class="tit flex">
              <div>授权设备:</div>
              <div class="col6">已选择：{{editform.device_id.length}}项</div>
            </div>
            <div class="authUserList flex mb20">
              <div class="userTree">
                <el-tree
                ref="tree"
                class="defineTree"
                :data="spaceList"
                highlight-current
                default-expand-all
                node-key="space_id"
                :expand-on-click-node="false"
                :props="adminTreeProp"
                @node-click="getNode2">
                  <span class="custom-tree-node" slot-scope="{ node,data }">
                    <i
                      class="defineIcon"
                      :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
                    </i>
                    <span class="label" :class="data.space_id === editform.space_id ? 'selectedTree' : ''">{{ node.label }}</span>
                  </span>
                </el-tree>
              </div>
              <div class="checkList">
                <div class="search">
                  <el-input size="small" placeholder="请输入搜索内容" prefix-icon="el-icon-search" v-model="editform.search" @input="searchDevice"></el-input>
                  <div class="sizeDiv" v-if="editform.type == 'ACCESS'">
                    <p>门禁级别：</p>
                    <el-checkbox-group v-model="editform.sizeCheck" @change="getSpaceDeviceSmzf(editform.type,'2',spaceList[0].space_id,editform.sizeCheck,editform.id)">
                      <el-checkbox label="A"></el-checkbox>
                      <el-checkbox label="B"></el-checkbox>
                      <el-checkbox label="C"></el-checkbox>
                    </el-checkbox-group>
                  </div>
                </div>
                <el-checkbox class="dblock" :indeterminate="editform.isIndeterminate" v-model="editform.checkAll" @change="CheckAllChange2">全选</el-checkbox>
                <el-checkbox-group class="groupH" v-model="editform.device_id" @change="CheckedItemChange2" v-if="deviceList.length !== 0">
                  <el-checkbox class="dblock" v-for="(item,index) in deviceList" :label="item.device_no_id" :key="index">{{item.device_no_id}}-{{item.device_name}}</el-checkbox>
                </el-checkbox-group>
                <p class="nullText" v-else>暂无{{editform.typeName}}设备</p>
              </div>
            </div>
            
            <el-form-item label="价格策略:" prop="tactics_id">
              <el-select v-model="editform.tactics_id" placeholder="请选择设备名称" class="db">
                <el-option
                  v-for="item in tacList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="editConfig('form2')">确定</el-button>
          <el-button @click="editConfigDio = false">取消</el-button>
        </span>
      </el-dialog>
      
      <!--删除配置-->
      <el-dialog title="" :visible.sync="statusDio" class="statusDio">
        <div class="statusCont">
          <div>是否删除该配置？</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="statusDio = false">取 消</el-button>
          <el-button type="primary" @click="delConfig">确定</el-button>
        </span>
      </el-dialog>

      <!--预览二维码-->
      <el-dialog title="" :visible.sync="previewDio" class="previewDio" width="350px">
        <div class="tr"><el-button v-print="'#ewm'">打印</el-button></div>
        <div class="img" id="ewm"><img :src="dioImageUrl" alt=""></div>
      </el-dialog>

      <!--查看价格策略和设备列表-->
      <el-dialog :title="tacticsName" :visible.sync="tacticsDio" width="700px">
        <div class="contDio">
          <div class="tabList" v-show="tacticsType == '1'">
            <el-table :data="tacticsData" style="width: 100%">
              <el-table-column label="序号" type="index"></el-table-column>
              <el-table-column label="设备ID" prop="device_no_id"></el-table-column>
              <el-table-column label="设备名称" prop="device_name"></el-table-column>
              <el-table-column label="设备编号" prop="device_num"></el-table-column>
              <el-table-column label="设备类型" prop="device_type"></el-table-column>
            </el-table>
          </div>
          <div class="tabList" v-show="tacticsType == '2'">
            <el-table :data="tacticsData" style="width: 100%">
              <el-table-column label="价格名称" prop="name"></el-table-column>
              <el-table-column label="支付平台">
                <template slot-scope="scope">
                  <span v-if="scope.row.pay_way == '1'">微信</span>
                  <span v-if="scope.row.pay_way == '2'">支付宝</span>
                </template>
              </el-table-column>
              <el-table-column label="计费方式">
                <template slot-scope="scope">
                  <span v-if="scope.row.time_type == '0'">按次数</span>
                  <span v-if="scope.row.time_type == '1'">按小时</span>
                  <span v-if="scope.row.time_type == '2'">按天</span>
                  <span v-if="scope.row.time_type == '3'">按月</span>
                </template>
              </el-table-column>
              <el-table-column label="费用" prop="">
                <template slot-scope="scope">{{scope.row.amount | priceFilter}}</template>
              </el-table-column>
              <el-table-column label="周末费用">
                <template slot-scope="scope">{{scope.row.amount_weekend | priceFilter}}</template>
              </el-table-column>
              <el-table-column label="节假日费用">
                <template slot-scope="scope">{{scope.row.amount_holiday | priceFilter}}</template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!-- <span slot="footer" class="dialog-footer">
          <el-button type="primary">确定</el-button>
          <el-button @click="tacticsDio = false">取 消</el-button>
        </span> -->
      </el-dialog>
  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast,localUserInfo } from "../../../../static/js/utility/utility.js"
  import { unmanApi,eSiteApi,sceneApi, bussinessApi,userApi,deviceApi } from "../../../../static/js/api.js"

  export default {
    name: 'CExConfigSetting',
    components: {
      CBreadCrumb
    },
    filters: {
      priceFilter: function (value) {
          return '￥'+value;
      },
    },
    data() {
      return {
        keyword:{
          device_id:'',
        },

        configList:[],//配置列表
        tableLoading:false,
        //分页
        curr:1,//当前页
        page:10,//显示个数
        total:0,//总数据

        addConfigDio:false,//添加弹窗
        addform:{
          device_name:'',//设备名称
          device_id:[],//设备id
          space_id:[],//空间id
          type:'',//设备类型
          tactics_id:'',//价格策略id
          search:'',//搜索
          isIndeterminate:false,//全选样式
          checkAll:false,
          sizeCheck:['A','B','C'],
        },
        typeList:[],//设备类型列表
        tacList:[],//价格策略列表
        spaceList:[],//空间列表
        deviceList:[],//设备列表
        // 级联选择器配置
        selectProps: {
          label: 'space_name',
          value: 'space_id',
          children: 'children'
        },

        editConfigDio:false,//添加弹窗
        editform:{
          id:'',
          device_name:'',//设备名称
          device_id:'',//设备id
          space_id:[],//空间id
          type:'',//设备类型
          tactics_id:'',//价格策略id
          search:'',//搜索
          isIndeterminate:false,//全选样式
          checkAll:false,
          sizeCheck:['A','B','C'],
        },

        statusDio:false,
        del_id:'',

        previewDio:false,//预览二维码
        dioImageUrl:'',//二维码地址

        tacticsDio:false,
        tacticsData:[],
        tacticsType:'',
        tacticsName:'',

        adminTreeProp:{
          id:'space_id',
          label:'space_name',
          children:'children',
        },

        allDevice:[],

      };
    },
    mounted(){

    },
    created () {
      this.getWarehouse()
      this.getSpaceList()
      this.gettacticsList()
      this.gettypeList()
    },
    methods: {
      //全选(修改)
      CheckAllChange2(val) {
        var arr = []
        for(var i in this.deviceList){
          arr.push(this.deviceList[i].device_no_id)
        }
        arr = Array.from(new Set(arr))
        this.editform.device_id = val ? arr : [];
        this.editform.isIndeterminate = false;
      },
      //选择多个（修改）
      CheckedItemChange2(value) {
        let checkedCount = value.length;
        this.editform.checkAll = checkedCount === this.deviceList.length;
        this.editform.isIndeterminate = checkedCount > 0 && checkedCount < this.deviceList.length;
      },
      //获取树形节点(修改)
      getNode2(node){
        let that = this;
        this.editform.space_id = node.space_id
        this.getSpaceDeviceSmzf(this.editform.type,'2',node.space_id,this.editform.sizeCheck,this.editform.id)
      },
      //全选(添加)
      CheckAllChange(val) {
        var arr = []
        for(var i in this.deviceList){
          arr.push(this.deviceList[i].device_no_id)
        }
        arr = Array.from(new Set(arr))
        this.addform.device_id = val ? arr : [];
        this.addform.isIndeterminate = false;
      },
      //选择多个(添加)
      CheckedItemChange(value) {
        console.log('value', value)
        // let checkedCount = value.length
        // this.addform.checkAll = checkedCount === this.deviceList.length;
        // this.addform.isIndeterminate = checkedCount > 0 && checkedCount < this.deviceList.length
      },
      //获取树形节点(添加)
      getNode(node){
        let that = this;
        this.addform.space_id = node.space_id
        this.getSpaceDeviceSmzf(this.addform.type,'1',node.space_id,this.addform.sizeCheck)
      },
      //设备类型改变
      typeChange(type){
        let that = this
        this.deviceList=[]
        let key
        if(type == '1'){
          that.getSpaceDeviceSmzf(that.addform.type,'1',that.addform.space_id,this.addform.sizeCheck)
          key = 'addform'
        }else{
          that.getSpaceDeviceSmzf(that.editform.type,'2',that.editform.space_id,this.editform.sizeCheck,this.editform.id)
          key = 'editform'
        }
        that.typeList.forEach((item)=>{
          if (item.code === that[key].type) { that[key].typeName = item.name }
        })
      },
      //修改配置
      editConfig(formName){
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.submitConfig(that.editform.id)
          } else {
            return false;
          }
        });
      },
      //打开价格策略
      openTactics(tactics,type){
        this.tacticsData = []
        this.tacticsType = type
        if(type == '2'){
          this.tacticsName = '查看价格策略'
          this.tacticsData.push(tactics)
        }else{
          this.tacticsName = '查看设备ID'
          this.tacticsData = tactics
        }
        this.tacticsDio = true;
      },
      //查看二维码
      async previewImg(id,type){
        let that = this;
        let company_ic = localUserInfo.getItem().company_ic
        let company_id = localUserInfo.getItem().company_id
        const dataObj = {
          data:{
            "page": "pages/login/login",
            "scene": company_ic+type+id
          },
          mode: "getUnlimited",
          type: type,
          company_id: company_id
        }
        const res = await deviceApi.previewImg(dataObj)
        if (res.meta.code === 200) {
          that.dioImageUrl = res.data.image_url
          that.previewDio = true
        } else {
          showToast(res.meta.message)
        }
      },
      //打开删除弹窗
      openStatus(index){
        this.del_id = this.configList[index].id
        this.statusDio = true;
      },
      //删除授权用户
      async delConfig(){
        let that = this;
        let data = {
          'id': that.del_id,//授权用户id
        }
        let res = await bussinessApi.delSmzfConfig(data)
        if (res.meta.code === 200) {
          that.getWarehouse(1)
          that.statusDio = false;
          showToast('删除成功！')
        } else {
          showToast(res.meta.message)
        }
      },
      
      
      //添加配置
      addConfig(formName){
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.submitConfig()
          } else {
            return false;
          }
        });
      },
      //提交配置
      async submitConfig(id){
        let that = this
        if(id){
          var data = {
            'id': id,
            'code':that.editform.type,
            'device_no_id':that.editform.device_id,
            'tactics_id': that.editform.tactics_id,
          }
        }else{
          var data = {
            'code':that.addform.type,
            'device_no_id':that.addform.device_id,
            'tactics_id': that.addform.tactics_id,
          }
        }

        if (data.device_no_id.length === 0) {
          showToast('请选择设备')
          return
        }
        if (data.tactics_id === '') {
          showToast('请选择价格策略')
          return
        }
        console.log('data', data)

        const res = await bussinessApi.configSmzf(data)
        if (res.meta.code === 200) {
          if(id){
            that.deviceList=[]
            that.editConfigDio = false
            that.getWarehouse()
          }else{
            that.addform={
              device_name:'',
              device_id: [],
              tactics_id:'',
              space_id:[],
              type:'',
              search:'',//搜索
              isIndeterminate:false,//全选样式
              checkAll:false,
              sizeCheck:['A','B','C'],
            }
            that.deviceList=[]
            that.addConfigDio = false
            that.getWarehouse(1)
          }
          showToast('配置成功！')
        }else{
          showToast(res.meta.message)
        }
      },
      //打开添加弹窗
      openAdd(){
        this.deviceList=[]
        this.addform.space_id = this.spaceList[0].space_id
        this.addform.type = this.typeList[0].code
        this.addform.typeName = this.typeList[0].name
        this.getSpaceDeviceSmzf(this.addform.type,'1',this.spaceList[0].space_id,this.addform.sizeCheck)
        this.addConfigDio = true;
      },
      //打开编辑弹窗
      openEdit(index){
        this.deviceList=[]
        this.editform.space_id = this.spaceList[0].space_id
        this.editform.id = this.configList[index].id
        this.editform.type = this.configList[index].code
        this.editform.typeName = this.configList[index].name
        var arr = []
        for(var i in this.configList[index].device_info){
          arr.push(this.configList[index].device_info[i].device_no_id)
        }
        this.editform.device_id = arr
        
        this.editform.tactics_id = this.configList[index].tactics_id
        this.getSpaceDeviceSmzf(this.editform.type,'2',this.spaceList[0].space_id,this.editform.sizeCheck,this.editform.id)
        this.editConfigDio = true;
      },
      //设备类型列表
      async gettypeList(){
        let that = this
        const res = await bussinessApi.getConfigDeviceList()
        if (res.meta.code === 200) {
          that.typeList = res.data
        } else {
          showToast(res.meta.message)
        }
      },
      //价格策略列表
      async gettacticsList(){
        let that = this
        const res = await bussinessApi.tacticsList()
        if (res.meta.code === 200) {
          that.tacList = res.data.list
        } else {
          showToast(res.meta.message)
        }
      },
      //获取空间列表
      async getSpaceList(){
        let that = this
        let res = await sceneApi.space()
        if (res.meta.code === 200) {
          this.spaceList = [...res.data]
          // that.processScene(res.data) // 汕头移动需注释
        } else {
          showToast(res.meta.message)
        }
      },
      // 处理位置数据
      processScene(data) {
        let that = this
        var arr = []
        if ( data.length !== 0) {
          // 显示某个公司或其下级空间的设备列表
          let list = data
          // 获取所属位置列表
          for (let s in list) {
            let area =  list[s].children
            for (let i in area) {
              let street = area[i].children
              for (let j in street) {
                let company = street[j]
                arr.push(company)
              }
            }
          }
          this.spaceList = arr
        }

      },
      //通过空间id获取预约的设备列表
      async getSpaceDeviceSmzf(code,type,space_id,size,id){
        let that = this;
        const data = {
          'space_id': space_id,
          'code': code,
          // 'level_type': size.join(',')
        }
        if(type == '2'){
          data.id = id
        }
        if(code == 'ACCESS'){
          data.level_type = size.join(',')
        }
        const res = await bussinessApi.getSpaceDeviceSmzfcode(data)
        if(res.meta.code == 200){
          // that.deviceList = res.data
          that.allDevice = res.data
          that.searchDevice()
        }else{
          showToast(res.meta.message)
        }
      },
      //搜索筛选
      searchDevice(){
        let that = this;
        var allDevice = this.allDevice
        var searchList = []
        for(var i in allDevice){
          if(that.addform.search!=''){
            if(allDevice[i].device_name.indexOf(that.addform.search) != -1 || allDevice[i].device_no_id.indexOf(that.addform.search) != -1){
              searchList.push(allDevice[i])
            }
          }else if(that.editform.search!=''){
            if(allDevice[i].device_name.indexOf(that.editform.search) != -1 || allDevice[i].device_no_id.indexOf(that.editform.search) != -1){
              searchList.push(allDevice[i])
            }
          }else{
            searchList = allDevice
          }
        }
        // console.log('searchList',searchList)
        this.deviceList = searchList
      },
      
      //获取配置设置列表
      async getWarehouse(curr,limits){
        let that = this;
        this.tableLoading = true
        const data = {
          'page':curr ? curr : that.curr,//当前页
          'perPage': limits ? limits : that.page,//每页条数
          'device_no_id': that.keyword.device_id,//设备id
        }
        let res = await bussinessApi.smzfConfigList(data)
        if(res.meta.code == 200){
          that.configList = res.data.list
          that.total = parseInt(res.data.total)
          that.tableLoading = false
        }else{
          that.tableLoading = false
          showToast(res.meta.message)
        }
      },
      //分页
      CurrentChange(val) {
        this.curr = val
        this.getWarehouse(val)
      },
    },
    watch: {
      
      
    }
  }
</script>

<style lang="scss">
.CExConfigSetting{
  .flex{
    display: flex;
  }
  .mb20{margin-bottom:20px;}
  .configDio{
    .selectedTree{
      font-weight: bold;
    }
    .authUserList{
      border: 1px solid #eee;
      align-items: flex-start !important;
      .userTree{
        width: 44%;
        height: 300px;
        overflow-y: auto;
        border-right: 1px solid #eee;
        flex-shrink: 0;
      }
      .checkList{
        flex-grow: 1;
        .search{
          // text-align: center;
          padding: 6px 0 0;
          display: flex;
          justify-content: center;
          align-items: center;
          .el-input{
            width: 50%;
            .el-input__inner{
              border-radius: 16px;
            }
          }
          .sizeDiv{
            margin-left: 10px;
            .el-checkbox{
              margin-right: 10px;
            }
          }
        }
        .el-checkbox.dblock{
          display: flex;
          justify-content: space-between;
          margin: 8px 0;
          flex-direction: row-reverse;
          padding-right: 16px;
          .el-checkbox__label{
            padding-left:16px;
          }
        }
        .el-checkbox-group.groupH{
          height: 227px;
          overflow-y: auto;
          border-top: 1px solid #eee;
        }
        .nullText {
          text-align: center;
          margin-top: 70px;
          color: #999999;
        }
      }
    }
    .flex{
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .tit{
      padding-left: 10px;
      padding-bottom: 10px;
      font-size: 14px;
      color: #333;
    }
    .authUser{
      border:1px solid #e4e7ed;
      align-items: flex-start;
      .userTree{
        width: 200px;
        border-right: 1px solid #e4e7ed;
        height: 300px;
        overflow-y: auto;
      }
      .checkList{
        flex: 1;
        height: 300px;
        overflow-y: auto;
        padding: 20px;
        .el-checkbox-group{
          display: flex;
          flex-wrap: wrap;
          .checkItem{
            width: 33.33%;
            .el-checkbox{ 
              margin-bottom: 10px;
              display: flex;
              align-items: center;
              .el-checkbox__label{
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
        
      }
    }
  }
  .tranferEdit{
    align-items: center;
    .tranItem{
      width: 255px;
      border: 1px solid #ebeef5;
      border-radius: 4px;
      max-height: 100%;
      box-sizing: border-box;
      overflow: hidden;
      .search{
        margin: 15px;
      }
      .tranTit{
        height: 40px;
        display: flex;
        justify-content: space-between;
        padding: 0 15px;
        box-sizing: border-box;
        background: #ebeef5;
        align-items: center;
      }
      .tranList{
        height: 194px;
        overflow-y: auto;
        overflow-x: hidden;
        box-sizing: border-box;
        .noData{
          text-align: center;
          padding: 20px;
        }
        .el-checkbox{
          padding: 0 15px;
          height: 30px;
          line-height: 30px;
          display: flex;
          align-items: center;
          .el-checkbox__label{
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            height: 30px;
            line-height: 30px;
          }
        }
      }
    }
    .btnDiv{
      padding: 0 30px;
      .el-button{
        margin: 5px 0;
      }
    }
  }
  .previewDio{
    .tr{
      text-align: right;
      el-button{
        display: inline-block;
        line-height: 1;
        padding: 12px 20px;
        border:1px solid #DCDFE6;
        font-size: 14px;
        color: #606266;
        border-radius: 4px;
      }
    }
    .img{
      width: 200px;
      width: 200px;
      margin: 0px auto;
      padding: 20px;
      img{ width:100%; }
    }
  }
  
  .dib{
    display:inline-block;
  }
  .db{
    display:block;
  }
  .contDio{
    .el-select{ display:inline-block;}
    .itemName{
      margin: 0 10px 0 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CTactics/CTConfigSetting.vue